<mat-slide-toggle
    class="example-margin"
    color="primary"
    [checked]="inputBoolean"
    [disabled]="dis"
    (change)="changeChecked()">
    {{txtTitulo}}
    <span *ngIf="txtFalse && txtTrue">:
        <span *ngIf="inputBoolean; else estadoT">{{txtTrue}}</span>
        <ng-template #estadoT>
            <span>{{txtFalse}}</span>
        </ng-template>
    </span>
</mat-slide-toggle>
